export default "__VITE_ASSET__Dg9q7zmo__"